import Vue from 'vue'
import VueRouter from 'vue-router'
import industries from '@/data/industries'

Vue.use(VueRouter)

const routes = [
    { path: '/', name: 'Home',
      component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue') },
    { path: '/services', name: 'Services',
      component: () => import(/* webpackChunkName: "services" */ '../views/Services.vue') },
    { path: '/projects', name: 'Projects',
      component: () => import(/* webpackChunkName: "projects" */ '../views/Projects.vue') },
    { path: '/about', name: 'about',
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue') },
    { path: '/contact', name: 'Contact',
      component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue') },
    { path: '/privacy', name: 'privacy',
      component: () => import(/* webpackChunkName: "privacy" */ '../views/termsOfUse.vue') },
    // one page component serves every industry in src/data/industries.js
    ...industries.map((i) => ({
        path: i.path,
        name: i.name,
        props: { slug: i.name },
        component: () => import(/* webpackChunkName: "industry" */ '../views/Industry.vue')
    })),
    { path: '*', name: 'NotFound',
      component: () => import(/* webpackChunkName: "notfound" */ '../views/NotFound.vue') }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

export default router
